var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4766 1.09375H10.8672V0H9.85156V1.09375H3.14844V0H2.13281V1.09375H1.52344C0.683414 1.09375 0 1.82973 0 2.73438V12.3594C0 13.264 0.683414 14 1.52344 14H11.4766C12.3166 14 13 13.264 13 12.3594V2.73438C13 1.82973 12.3166 1.09375 11.4766 1.09375ZM11.9844 12.3594C11.9844 12.6609 11.7566 12.9062 11.4766 12.9062H1.52344C1.24343 12.9062 1.01562 12.6609 1.01562 12.3594V5.14062H11.9844V12.3594ZM11.9844 4.04688H1.01562V2.73438C1.01562 2.43283 1.24343 2.1875 1.52344 2.1875H2.13281V3.28125H3.14844V2.1875H9.85156V3.28125H10.8672V2.1875H11.4766C11.7566 2.1875 11.9844 2.43283 11.9844 2.73438V4.04688Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.94531 6.28906H1.92969V7.38281H2.94531V6.28906Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.97656 6.28906H3.96094V7.38281H4.97656V6.28906Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00781 6.28906H5.99219V7.38281H7.00781V6.28906Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.03906 6.28906H8.02344V7.38281H9.03906V6.28906Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0703 6.28906H10.0547V7.38281H11.0703V6.28906Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.94531 8.47656H1.92969V9.57031H2.94531V8.47656Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.97656 8.47656H3.96094V9.57031H4.97656V8.47656Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00781 8.47656H5.99219V9.57031H7.00781V8.47656Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.03906 8.47656H8.02344V9.57031H9.03906V8.47656Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2.94531 10.6641H1.92969V11.7578H2.94531V10.6641Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M4.97656 10.6641H3.96094V11.7578H4.97656V10.6641Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00781 10.6641H5.99219V11.7578H7.00781V10.6641Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M9.03906 10.6641H8.02344V11.7578H9.03906V10.6641Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0703 8.47656H10.0547V9.57031H11.0703V8.47656Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar_icon.13919120.svg";
export { ForwardRef as ReactComponent };